export default __webpack_public_path__ + "static/foreground4.webp-9f5acafdf42bda466a15689373668e1d.png";